export default Object.freeze({
  NotConfigured: 1,
  PendingVerification: 2,
  Verified: 3,
  Active: 4,
  Disabled: 5,
});
